import React from "react";
import { List, Datagrid, EditButton, TextField } from "react-admin";

export default (props) => (
  <List {...props} perPage={50} pagination={false}>
    <Datagrid rowClick="edit">
      <TextField source="fromName" />
      <TextField source="fromEmail" />
      <TextField source="fromBounceEmail" />
      <TextField source="type" />
      <EditButton />
    </Datagrid>
  </List>
);
